<app-loader *ngIf="isDisabled"></app-loader>
<form name="TaxFinancialYearForm" (ngSubmit)="Validate(TaxFinancialYearForm)" #TaxFinancialYearForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Tax Financial Year</label>
        </div>
        <div class="card-body">
            <div class="row m-1 g-1">
                <div class="col-md-4">
                    <div class="row g-1">
                        <div class="col-12">
                            <div class="bghighlight p-1">
                                <div class="row">
                                    <div class="text-label">Financial Year Start</div>
                                </div>
                                <div class="row text-right">
                                    <div>{{this.Detail.FinancialYearStart | date: 'dd MMM yyyy'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="bghighlight p-1">
                                <div class="row">
                                    <div class="text-label">Financial Year End</div>
                                </div>
                                <div class="row text-right">
                                    <div>{{this.Detail.FinancialYearEnd | date: 'dd MMM yyyy'}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="bghighlight p-1">
                                <div class="row">
                                    <div class="text-label">Education Cess Perc</div>
                                </div>
                                <div class="row text-right">
                                    <div>{{this.Detail.EducationCessPerc}}%</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="row g-1">
                        <div class="col-md">
                            <div class="col-12 bghighlight p-1">
                                <div class="row text-center">
                                    <div class="text-label">Old Regime</div>
                                </div>
                                <hr class="m-1" />
                            </div>
                            <div class="row m-0 p-0">
                                <div class="col-md bghighlight p-1">
                                    <div class="row">
                                        <div class="text-label">Standard Deduction</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{this.Detail.OldRegimeStandardDeduction}}</div>
                                    </div>
                                </div>
                                <div class="col-md bghighlight p-1">
                                    <div class="row">
                                        <div class="text-label">Rebate</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{this.Detail.OldRegimeRebate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="col-12 bghighlight p-1">
                                <div class="row text-center">
                                    <div class="text-label">New Regime</div>
                                </div>
                                <hr class="m-1" />
                            </div>
                            <div class="row m-0 p-0">
                                <div class="col-md bghighlight p-1">
                                    <div class="row">
                                        <div class="text-label">Standard Deduction</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{this.Detail.NewRegimeStandardDeduction}}</div>
                                    </div>
                                </div>
                                <div class="col-md bghighlight p-1">
                                    <div class="row">
                                        <div class="text-label">Rebate</div>
                                    </div>
                                    <div class="row text-right">
                                        <div>{{this.Detail.NewRegimeRebate}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row g-1 p-2 align-items-center">
                        <div class="col-md-4">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="PANValidationRequired"
                                    id="PANValidationRequired" [(ngModel)]="this.Detail.PANValidationRequired">
                                <label class="text-label" for="PANValidationRequired">
                                    PAN Validation Required
                                </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="IsDraftInvestmentAllowed"
                                    id="IsDraftInvestmentAllowed" [(ngModel)]="this.Detail.IsDraftInvestmentAllowed">
                                <label class="text-label" for="IsDraftInvestmentAllowed">
                                    IsDraft Investment Allowed
                                </label>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="text-label">Default Regime<span class="mandatory-field">*</span></label>
                            <ng-select name="DefaultRegimeSelection" [items]="Regimes" bindLabel="Name"
                                bindValue="value" [(ngModel)]="this.Detail.DefaultRegimeSelection" placeholder="Regime" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select default regime!
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label class="text-label">Tax Based On<span class="mandatory-field">*</span></label>
                            <ng-select name="TaxBasedon" [items]="TaxBasedOnLoad" bindLabel="Name"
                                bindValue="value" [(ngModel)]="this.Detail.TaxBasedon" placeholder="Tax Based On" required>
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select default regime!
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" name="IsActive" id="IsActive"
                                    [(ngModel)]="this.Detail.IsActive">
                                <label class="text-label" for="IsActive">
                                    IsActive
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-1 g-1">
                <div class="col-md border border-dark">
                    <div class="col-12 p-1">
                        <div class="row text-center">
                            <div class="text-label">Declaration</div>
                        </div>
                        <hr class="m-1" />
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md p-0">
                            <div class="p-1">
                                <div class="row">
                                    <div class="text-label">Open Date <span class="mandatory-field">*</span></div>
                                </div>
                                <div class="row text-right">
                                    <div class="input-group">
                                        <input class="form-control" name="DeclarationOpenDateObj"
                                            placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                            #DeclarationOpenDate="ngbDatepicker"
                                            [(ngModel)]="this.Detail.DeclarationOpenDateObj"
                                            #DeclarationOpenDateObj="ngModel" readonly required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="DeclarationOpenDate.toggle()" type="button"></button>
                                    </div>

                                    <div class="invalid-feedback">
                                        Please enter open date !
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md p-0">
                            <div class="p-1">
                                <div class="row">
                                    <div class="text-label">Last Date <span class="mandatory-field">*</span></div>
                                </div>
                                <div class="row text-right">
                                    <div class="input-group">
                                        <input class="form-control" name="DeclarationLastDateObj"
                                            placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                            #DeclarationLastDate="ngbDatepicker"
                                            [(ngModel)]="this.Detail.DeclarationLastDateObj"
                                            #DeclarationLastDateObj="ngModel" readonly required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="DeclarationLastDate.toggle()" type="button"></button>
                                    </div>

                                    <div class="invalid-feedback">
                                        Please enter open date !
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto p-0 align-content-center">
                            <div class="p-1">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="IsMultipleDeclarationAllowed"
                                        id="IsMultipleDeclarationAllowed"
                                        [(ngModel)]="this.Detail.IsMultipleDeclarationAllowed">
                                    <label class="text-label" for="IsMultipleDeclarationAllowed">
                                        Is Multiple
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md border border-dark">
                    <div class="col-12 p-1">
                        <div class="row text-center">
                            <div class="text-label">Investment</div>
                        </div>
                        <hr class="m-1" />
                    </div>
                    <div class="row m-0 p-0">
                        <div class="col-md p-0">
                            <div class="p-1">
                                <div class="row">
                                    <div class="text-label">Open Date <span class="mandatory-field">*</span></div>
                                </div>
                                <div class="row text-right">
                                    <div class="input-group">
                                        <input class="form-control" name="InvestmentOpenDateObj"
                                            placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                            #InvestmentOpenDate="ngbDatepicker"
                                            [(ngModel)]="this.Detail.InvestmentOpenDateObj"
                                            #InvestmentOpenDateObj="ngModel" readonly required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="InvestmentOpenDate.toggle()" type="button"></button>
                                    </div>

                                    <div class="invalid-feedback">
                                        Please enter open date !
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md p-0">
                            <div class="p-1">
                                <div class="row">
                                    <div class="text-label">Last Date <span class="mandatory-field">*</span></div>
                                </div>
                                <div class="row text-right">
                                    <div class="input-group">
                                        <input class="form-control" name="InvestmentLastDateObj"
                                            placeholder="Ex. DD MMM YYYY" ngbDatepicker
                                            #InvestmentLastDate="ngbDatepicker"
                                            [(ngModel)]="this.Detail.InvestmentLastDateObj"
                                            #InvestmentLastDateObj="ngModel" readonly required />
                                        <button class="btn btn-outline-secondary bi bi-calendar3"
                                            (click)="InvestmentLastDate.toggle()" type="button"></button>
                                    </div>

                                    <div class="invalid-feedback">
                                        Please enter open date !
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-auto p-0 align-content-center">
                            <div class="p-1">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox"
                                        name="IsMultipleProofSubmissionAllowed" id="IsMultipleProofSubmissionAllowed"
                                        [(ngModel)]="this.Detail.IsMultipleProofSubmissionAllowed">
                                    <label class="text-label" for="IsMultipleProofSubmissionAllowed">
                                        Is Multiple
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-md-12 px-1">
                    <label for="Name">Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="Name" placeholder="Ex. Name"
                        [(ngModel)]="Detail.Name" #Name="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter name !
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <label for="FromAge">From Age</label>
                    <input type="text" class="form-control" placeholder="Ex. 18" id="FromAge" name="FromAge"
                        [(ngModel)]="Detail.FromAge" #FromAge="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="3">
                    <div class="invalid-feedback">
                        Please enter from age !
                    </div>
                </div>
                <div class="col-md-6 px-1">
                    <label for="ToAge">To Age</label>
                    <input type="text" class="form-control" placeholder="Ex. 30" id="ToAge" name="ToAge"
                        [(ngModel)]="Detail.ToAge" #ToAge="ngModel" pattern="^[0-9]\d*$"
                        (keypress)="common.NumberOnly($event)" maxlength="3">
                    <div class="invalid-feedback">
                        Please enter to age !
                    </div>
                </div> -->
            <!-- <div class="col-md-6 px-1">
                    <label for="Category">Category</label>
                    <select class="form-control form-select" name="Category" [(ngModel)]="Detail.Category"
                        #Category="ngModel" required>
                        <option [value]=null hidden disabled>Select Category</option>
                        <option value='Male'>Male</option>
                        <option value='Female'>Female</option>
                        <option value='Other'>Other</option>
                    </select>
                    <div class="invalid-feedback">
                        Please select category.
                    </div>
                </div> -->
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button *ngIf="(this.Detail.ESS_TaxFinancialYearID > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>